import { RefundEntity } from "./RefundEntity"

export interface RefundOperationCriteria {
    operation: string | null,
    remark: string | null,
    bankerIdAndBankerAcNo: string | null,
    selectRows: RefundEntity[] | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_REFUND_OPERATION_CRITERIA: RefundOperationCriteria = {
    operation: null,
    selectRows: [],
    remark: null,
    bankerIdAndBankerAcNo: null
}
